module.exports = "<div class=\"alert alert-info alert-dismissible fade show\" role=\"alert\">\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" data-dismiss=\"alert\">\n            <span aria-hidden=\"true\">&times;</span>\n      </button>\n      I am an alert and I can be dismissed!\n</div>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/components/Alerts/AlertUncontrolledDismiss.html
// module id = 426
// module chunks = 0